export const buttonComputed = {
  computed: {
    buttonElStyles() {
      const btn = this.button || {};
      const corners = btn.corners || {};
      const fillStyle = btn.fillStyle || {};
      const backgroundColor = btn.backgroundColor || {};
      const textColor = btn.textColor || {};

      // fill styles
      let bgColorBorderColor = {};
      if (fillStyle && fillStyle.value === "fill") {
        bgColorBorderColor.backgroundColor = backgroundColor && backgroundColor.value ? backgroundColor.value : "#ffffff";
        bgColorBorderColor.border = `2px solid transparent`;
      } else if (fillStyle && fillStyle.value === "border") {
        const bg = backgroundColor && backgroundColor.value ? backgroundColor.value : "#cccccc";
        bgColorBorderColor.border = `2px solid ${bg}`;
        bgColorBorderColor.backgroundColor = "transparent";
      }

      // direct styles
      const styles = {
        borderRadius:
          corners && corners.value === "round" ? "var(--button-border-radius)" : 0,
        color: textColor && textColor.value ? textColor.value : "inherit",
        ...bgColorBorderColor,
      };
      // return
      return styles;
    },
  },
};
